import {
  LuAirplay,
  LuAperture,
  LuArchive,
  LuArrowUpNarrowWide,
  LuBookOpenCheck,
  LuBuilding2,
  LuBus,
  LuContainer,
  LuFile,
  LuFileEdit,
  LuFileInput,
  LuFileMinus2,
  LuFileOutput,
  LuFilePlus2,
  LuFileX,
  LuHome,
  LuPopcorn,
  LuShapes,
  LuSpline,
  LuStore,
  LuTable,
  LuTablets,
  LuTicket,
  LuUser2,
  LuUserCheck,
  LuUsers,
  LuUsers2,
} from "react-icons/lu";
import { MenuItemType, MenuType } from "../types/menu.type";
import { ContainerOwnProps } from "@mui/material";
import {
  MdOutlineDiscount,
  MdOutlinePayment,
  MdOutlineTableRestaurant,
} from "react-icons/md";
import { BsTicket } from "react-icons/bs";

const HEADER_HEIGHT: string = "60px";
const SIDEBAR_MINWIDTH: string = "72px";
const SIDEBAR_MAXWIDTH: string = "260px";
const MOBILE_CONTAINER: ContainerOwnProps["maxWidth"] = "sm";

const DEFAULT_CUSTOMER = { ma_kh: 1, ten_kh: "Khách lẻ" };

const MENUS: MenuType[] = [
  {
    subheader: "Tổng quan",
    path: "/",
  },
  {
    subheader: "Quản lý siêu thị",
    items: [
      { text: "Danh sách hàng hóa", Icon: LuShapes, path: "/list/hanghoa" },
      { text: "Nhóm hàng hóa", Icon: LuContainer, path: "/list/nhomhang" },
      { text: "Quy đổi đơn vị tính", Icon: LuAperture, path: "/list/dmqddvt" },
      { text: "Tồn đầu kỳ", Icon: LuArchive, path: "/list/cdvt" },
      { text: "Kiểm kê", Icon: LuBookOpenCheck, path: "/list/pkk" },
      { text: "Phiếu bán lẻ", Icon: LuFile, path: "/list/pbl" },
      { text: "Trả hàng", Icon: LuFileEdit, path: "/list/hd7" },
      { text: "Nhập hàng", Icon: LuFileInput, path: "/list/pn1" },
      { text: "Trả hàng nhập", Icon: LuFileOutput, path: "/list/pn5" },
      { text: "Xuất hủy", Icon: LuFileX, path: "/list/pxk" },
    ],
  },
  {
    subheader: "Quản lý quán ăn",
    items: [
      { text: "Danh sách món", Icon: LuPopcorn, path: "/list/monan" },
      { text: "Nhóm món", Icon: LuContainer, path: "/list/nhommon" },
      { text: "Đơn hàng", Icon: LuFile, path: "/list/hd_nh" },
      { text: "Phiếu ăn", Icon: LuTable, path: "/list/dmban" },
      // { text: "Khu vực bàn", Icon: LuTable2, path: "/list/nhomban" },
    ],
  },
  {
    subheader: "Quản lý xe và đặt vé",
    items: [
      { text: "Nhà xe", Icon: LuBuilding2, path: "/list/dmnhaxe" },
      { text: "Loại xe", Icon: LuAirplay, path: "/list/dmloaixe" },
      { text: "Xe khách", Icon: LuBus, path: "/list/dmxe" },
      { text: "Tuyến đường", Icon: LuSpline, path: "/list/route" },
      { text: "Hạng vé", Icon: LuArrowUpNarrowWide, path: "/list/hangvexe" },
      // { text: "Hành trình", Icon: LuGitCompare, path: "/list/journeyplans" },
      // { text: "Vé", Icon: LuBanknote, path: "/list/evoucher" },
      { text: "Đặt vé", Icon: LuTicket, path: "/list/ticketsorder" },
    ],
  },
  {
    subheader: "Thu chi",
    items: [
      { text: "Phiếu thu", Icon: LuFilePlus2, path: "/list/pt1" },
      { text: "Phiếu chi", Icon: LuFileMinus2, path: "/list/pc1" },
      // { text: "Sổ quỹ", Icon: LuCoins, path: "/report/soquy" },
    ],
  },
  {
    subheader: "Thống kê",
    items: [
      {
        text: "Quán ăn",
        Icon: MdOutlineTableRestaurant,
        path: "/report/restaurant",
      },
      // { text: "Siêu thị", Icon: MdStorefront, path: "/report/supermarket" },
      { text: "Bán vé", Icon: BsTicket, path: "/report/ticket" },
      // { text: "Tổng hợp", Icon: BsPieChart, path: "/report/summary" },
    ],
  },
  {
    subheader: "Đối tác",
    items: [
      { text: "Khách hàng", Icon: LuUser2, path: "/list/customer" },
      { text: "Nhóm khách", Icon: LuUsers, path: "/list/dmnhkh" },
      { text: "Nhà cung cấp", Icon: LuUserCheck, path: "/list/dmncc" },
      { text: "Nhóm nhà cung cấp", Icon: LuUsers2, path: "/list/dmnhncc" },
    ],
  },
  {
    subheader: "Chính sách giá",
    items: [
      {
        text: "Chiết khấu sản phẩm",
        Icon: MdOutlineDiscount,
        path: "/list/dmchietkhau",
      },
    ],
  },
  {
    subheader: "Hệ thống",
    items: [
      {
        text: "Nhóm người dùng và phân quyền",
        Icon: LuUsers,
        path: "/list/usergroup",
      },
      {
        text: "Người dùng",
        Icon: LuUser2,
        path: "/list/participant",
      },
      { text: "Đơn vị tính", Icon: LuTablets, path: "/list/dmdvt" },
      {
        text: "Chi nhánh",
        Icon: LuStore,
        path: "/list/dmkho",
      },
      {
        text: "PT thanh toán",
        Icon: MdOutlinePayment,
        path: "/list/ptthanhtoan",
      },
    ],
  },
];

const HEADER_OPTIONS: MenuItemType[] = [
  {
    text: "Danh sách công ty",
    path: "/app",
    Icon: LuHome,
  },
];

const STORE_KEY = "store_key";
const BILL_KEY = "bill_key";

export {
  HEADER_HEIGHT,
  SIDEBAR_MINWIDTH,
  SIDEBAR_MAXWIDTH,
  MENUS,
  HEADER_OPTIONS,
  STORE_KEY,
  BILL_KEY,
  MOBILE_CONTAINER,
  DEFAULT_CUSTOMER,
};
